module.exports = __webpack_public_path__ + "assets/eba8519387529abc1084472562961ea2.png";